import { createContext, useEffect, useState } from "react";
export const ThemeContext = createContext();

// LIGHT THEME, Edit colors here for light mode
const lightTheme = {
  // Page Background
  "--website-bg": "linear-gradient(to right, #f7f6fc, #edeaf8)",

  // Hero Name Gradient
  "--hero-name-bg": "linear-gradient(to right, #54387a, #9175D8, #EDEAF8)",

  // 404 Name Gradient
  "--404-bg": "linear-gradient(to right, #54387a, #9175D8, #3e3658)",

  // Text Colors
  "--section-heading": "#54387a",
  "--website-text": "#28282B",
  "--icons-color": "#54387a",

  // Navbar
  "--nav-bg": "#edeaf8",
  "--nav-text": "#1a1025",
  "--nav-mobile-bg": "#54387a",
  "--nav-mobile-text": "#ffffff",
  "--nav-close": "#ffffff",
  "--nav-mobile-link-text": "#ffffff",
  "--nav-btn-bg": "#54387a",
  "--nav-btn-text": "#ffffff",
  "--nav-toggle-btn": "#54387a",

  // Cards
  "--card-bg": "#ffffff",
  "--card-border": "#54387a",
  "--card-text": "#28282B",
  "--card-icon-bg": "#54387a",
  "--card-icon-text": "#ffffff",


  // Badge
  "--badge-bg": "#ffffff",
  "--badge-text": "#28282b",

  // Form Inputs
  "--input-bg": "#ffffff",
  "--input-border": "#e2ddf0",
  "--input-text": "#28282B",
  "--input-placeholder": "#5f5f5f",
  "--input-focus-border": "#54387a",

  // Buttons
  "--btn-bg": "#54387a",
  "--btn-text": "#ffffff",
  "--btn-secondary-bg": "#ffffff",
  "--btn-secondary-text": "#54387a",
  "--btn-secondary-hover-bg": "#4a3570",

  // Footer
  "--footer-bg": "#54387a",
  "--footer-text": "#ffffff",
  "--footer-btn-bg": "#ffffff",
  "--footer-btn-text": "#54387a",
};

// DARK THEME, Edit colors here for dark mode
const darkTheme = {
  // Page Background
  "--website-bg": "linear-gradient(to right, #1a1025, #2d1b4e)",

  // Hero Name Gradient
  "--hero-name-bg": "linear-gradient(to right, #E6E6FA, #9175D8)",

  // 404 Name Gradient
  "--404-bg": "linear-gradient(to right, #E6E6FA, #9175D8)",

  // Text Colors
  "--section-heading": "#E6E6FA",
  "--website-text": "#E6E6FA",
  "--icons-color": "#E6E6FA",

  // Navbar — matches page background for unified feel
  "--nav-bg": "linear-gradient(to right, #1a1025, #2d1b4e)",
  "--nav-text": "#E6E6FA",
  "--nav-mobile-bg": "#2d1b4e",
  "--nav-mobile-text": "#E6E6FA",
  "--nav-close": "#E6E6FA",
  "--nav-mobile-link-text": "#E6E6FA",
  "--nav-btn-bg": "#E6E6FA",
  "--nav-btn-text": "#1a1025",
  "--nav-toggle-btn": "#E6E6FA",

  // Cards — slightly lighter than background
  "--card-bg": "#362750",
  "--card-border": "#c9bfe8",
  "--card-text": "#c9bfe8",
  "--card-icon-bg": "#E6E6FA",
  "--card-icon-text": "#54387a",

  // Badge
  "--badge-bg": "#E6E6FA",
  "--badge-text": "#28282b",

  // Form Inputs
  "--input-bg": "#362750",
  "--input-border": "#4a3570",
  "--input-text": "#E6E6FA",
  "--input-placeholder": "#E6E6FA",
  "--input-focus-border": "#E6E6FA",

  // Buttons
  "--btn-bg": "#E6E6FA",
  "--btn-text": "#1a1025",
  "--btn-secondary-bg": "#E6E6FA",
   "--btn-secondary-text": "#54387a",
  "--btn-secondary-hover-bg": "#4a3570",

  // Footer — matches page background for unified feel
  "--footer-bg": "linear-gradient(to right, #1a1025, #2d1b4e)",
  "--footer-text": "#E6E6FA",
  "--footer-btn-bg": "#E6E6FA",
  "--footer-btn-text": "#1a1025",
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem("theme");
      return saved ? JSON.parse(saved) : false;
    } catch {
      return false;
    }
  });

  const toggleTheme = () => {
    setIsDark((prev) => {
      const newValue = !prev;
      try {
        localStorage.setItem("theme", JSON.stringify(newValue));
      } catch {}
      return newValue;
    });
  };

  useEffect(() => {
    const theme = isDark ? darkTheme : lightTheme;
    for (const key in theme) {
      document.documentElement.style.setProperty(key, theme[key]);
    }
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
